import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "pa-4" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_card_title = _resolveComponent("v-card-title");
    const _component_v_divider = _resolveComponent("v-divider");
    const _component_v_col = _resolveComponent("v-col");
    const _component_v_row = _resolveComponent("v-row");
    const _component_v_card = _resolveComponent("v-card");
    return (_openBlock(), _createBlock(_component_v_card, {
        width: "428",
        class: "brg-card-outlined",
        elevation: "0"
    }, {
        default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "contents-title-text" }, {
                default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.subTitle), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
            }),
            _createVNode(_component_v_divider),
            _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_v_row, { "no-gutters": "" }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "4" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "pa-0 body2-text brg-color-grey-600" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.lc}business_name`)), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        }),
                        _createVNode(_component_v_col, { cols: "8" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "pa-0 body2-text text-black" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.info.businessName), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _: 1 /* STABLE */
                }),
                _createVNode(_component_v_row, {
                    "no-gutters": "",
                    class: "pt-4"
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "4" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "pa-0 body2-text brg-color-grey-600" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.lc}ceo_name`)), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        }),
                        _createVNode(_component_v_col, { cols: "8" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "pa-0 body2-text text-black" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.info.ceoName), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _: 1 /* STABLE */
                }),
                _createVNode(_component_v_row, {
                    "no-gutters": "",
                    class: "pt-4"
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "4" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "pa-0 body2-text brg-color-grey-600" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.lc}business_number`)), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        }),
                        _createVNode(_component_v_col, { cols: "8" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "pa-0 body2-text text-black" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.info.businessNumber), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _: 1 /* STABLE */
                }),
                _createVNode(_component_v_row, {
                    "no-gutters": "",
                    class: "pt-4"
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "4" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "pa-0 body2-text brg-color-grey-600" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.lc}business_address`)), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        }),
                        _createVNode(_component_v_col, { cols: "8" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "pa-0 body2-text text-black" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.info.formattedFullAddress), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _: 1 /* STABLE */
                }),
                _createVNode(_component_v_row, {
                    "no-gutters": "",
                    class: "pt-4"
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "4" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "pa-0 body2-text brg-color-grey-600" }, {
                                    default: _withCtx(() => [
                                        _createCommentVNode("업태"),
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_ctx.lc}business_condition`)), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        }),
                        _createVNode(_component_v_col, { cols: "8" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "pa-0 body2-text text-black" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.info.businessCondition), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _: 1 /* STABLE */
                }),
                _createVNode(_component_v_row, {
                    "no-gutters": "",
                    class: "pt-4"
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "4" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "pa-0 body2-text brg-color-grey-600" }, {
                                    default: _withCtx(() => [
                                        _createCommentVNode("종목"),
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_ctx.lc}business_type`)), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        }),
                        _createVNode(_component_v_col, { cols: "8" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "pa-0 body2-text text-black" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.info.businessType), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _: 1 /* STABLE */
                }),
                _createVNode(_component_v_row, {
                    "no-gutters": "",
                    class: "pt-4"
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "4" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "pa-0 body2-text brg-color-grey-600" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t(`common.email`)), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        }),
                        _createVNode(_component_v_col, { cols: "8" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "pa-0 body2-text text-black" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.info.ceoEmail), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _: 1 /* STABLE */
                })
            ])
        ]),
        _: 1 /* STABLE */
    }));
}
